import forEach from '../lib/foreach'
import isMobile from '../lib/isMobile'
import imagesLoaded from 'imagesloaded'
import text from 'text-content'

export default class Gallery {
  constructor(el) {
    this.setVars(el)
    this.bindEvents()
  }

  findItem(needle) {
    let index = 0

    for (let key in this.items) {
      if (this.items[key].href == needle.href) {
        this.currentIndex = index
        return this.items[key]
      }

      index++
    }
  }

  bindEvents() {
    forEach(this.items, item => {
      item.el.addEventListener('click', this.activate.bind(this), false)
    })

    this.modal.close.addEventListener('click', this.hideModal.bind(this), false)
    this.nav.next.addEventListener('click', this.next.bind(this), false)
    this.nav.previous.addEventListener('click', this.previous.bind(this), false)
    window.addEventListener('resize', this.setModalSizes.bind(this), false)
    document.addEventListener('keydown', this.closeOnESC.bind(this), false)
  }

  setVars(el) {
    this.el = el
    this.items = []
    this.currentIndex = null
    this.modalShown = false
    this.modal = {
      caption: document.querySelector('.photo-modal-caption'),
      close: document.querySelector('.photo-modal-close'),
      credit: document.querySelector('.photo-modal-credit'),
      el: document.querySelector('.photo-modal'),
      figcaption: document.querySelector('.photo-modal-figcaption'),
      figure: document.querySelector('.photo-modal-figure'),
      image: document.querySelector('.photo-modal-image')
    }
    this.nav = {
      next: document.querySelector('.photo-modal .nav-next'),
      previous: document.querySelector('.photo-modal .nav-previous')
    }
    this.share = {
      pinterest: document.querySelector('.social-share-pinterest'),
      twitter: document.querySelector('.social-share-twitter'),
      facebook: document.querySelector('.social-share-facebook'),
      email: document.querySelector('.social-share-email')
    }

    forEach(document.querySelectorAll('.photo-item'), item => {
      this.items.push({
        el: item,
        href: item.querySelector('a').href,
        full: item.querySelector('a').getAttribute('data-full'),
        caption: text(item.querySelector('.photo-caption')),
        credit: 'Photo: ' + text(item.querySelector('.photo-credit'))
      })
    })
  }

  closeOnESC(e) {
    if (e.keyCode === 27) {
      this.hideModal()
    }
  }

  next() {
    if (this.currentIndex >= this.items.length - 1) {
      this.currentIndex = 0
    } else {
      this.currentIndex += 1
    }

    this.assignModalData(this.items[this.currentIndex])
  }

  previous() {
    if (this.currentIndex < 1) {
      this.currentIndex = this.items.length - 1
    } else {
      this.currentIndex -= 1
    }

    this.assignModalData(this.items[this.currentIndex])
  }

  showModal() {
    this.modal.el.classList.add('-active')
  }

  hideModal() {
    this.modal.el.classList.remove('-active')

    setTimeout(this.cleanUpModal.bind(this), 300)
  }

  setModalSizes() {
    if (isMobile()) {
      this.modal.image.style.maxHeight = ''
      return
    }

    let additionalMargin = window.innerHeight * 0.05
    let additionalOffset = 40
    let newHeight =
      window.innerHeight -
      this.modal.figcaption.offsetHeight -
      additionalOffset -
      additionalMargin

    this.modal.image.style.maxHeight = newHeight + 'px'
  }

  cleanUpModal() {
    this.currentIndex = null
    this.modal.image.src = ''
    this.modal.image.style.maxHeight = ''
    text(this.modal.caption, '')
    text(this.modal.credit, '')
  }

  activate(e) {
    e.preventDefault()

    this.showModal()

    let link = e.target.parentNode.parentNode
    let item = this.findItem(link)

    this.assignModalData(item)
  }

  assignModalData(item) {
    // Set copy for modal
    this.modal.image.src = item.full
    text(this.modal.caption, item.caption)
    text(this.modal.credit, item.credit)

    // When image is done loading, resize modal
    imagesLoaded(this.modal.image, () => {
      this.setModalSizes()
    })

    // Set Social
    this.share.facebook.href = `https://www.facebook.com/sharer/sharer.php?u=${
      item.href
    }`
    this.share.twitter.href = `https://twitter.com/intent/tweet/?text=Beautiful%20image&via=atlantic&url=${
      item.href
    }`
    this.share.pinterest.href = `https://www.pinterest.com/pin/create/button/?url=${
      item.href
    }&media=${item.full}&description=${item.caption}`
    this.share.email.href = `mailto:Enter%20Email%20Address?subject=Laying%20Foundations%20for%20Change%20from%20The%20Atlantic%20Philanthropies&body=Beautiful%20image:%20${
      item.href
    }`
  }
}



// WEBPACK FOOTER //
// ./src/javascript/features/gallery.js